// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import HttpService from 'src/lib/HttpService';

const JARVIS_URL_FOR_EMAIL_CHECK= `api/jarvis/JarvisCM/customers/get-by-email`;
const USTRL_DEVICE_REGISTRATION_URL= `api/ustrl/v2.0/devices`;

export default {
    async checkEmailValidity(body: any) {
        const response = await HttpService.proxiedApiCall({
            body,
            requestUrl: `${JARVIS_URL_FOR_EMAIL_CHECK}`,
            type: 'post',
        });
        return response;
    },

    async registerDevice(serialNumber: string, body: any) {
        const response = await HttpService.proxiedApiCall({
            body,
            requestUrl: `${USTRL_DEVICE_REGISTRATION_URL}/${serialNumber}/registrations`,
            type: 'post',
        });
        return response;
    },
};